module.exports = __webpack_public_path__ + "static/img/question-bank-to-top.d469bbc9.png";